
function closeAllTabs(wrapper) {
  if (!wrapper) return;
  const tabs = Array.from(wrapper.querySelectorAll(".tab-label"));
  tabs.forEach((tab) => {
    tab.setAttribute('aria-selected', 'false');
    const panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (panel) panel.setAttribute('hidden', '');
  });
  const btn = wrapper.querySelector(".tab-close-button");
  if (btn) btn.setAttribute('hidden', '');
}
 
function selectTab(tab) {
  const wrapper = tab.closest('.tab-wrapper');
  if (!wrapper) return;
 
  // Deselect all in this wrapper
  wrapper.querySelectorAll('.tab-label').forEach((t) => {
    t.setAttribute('aria-selected', 'false');
    const p = document.getElementById(t.getAttribute('aria-controls'));
    if (p) p.setAttribute('hidden', '');
  });
 
  // Select this tab
  tab.setAttribute('aria-selected', 'true');
  const panel = document.getElementById(tab.getAttribute('aria-controls'));
  if (panel) panel.removeAttribute('hidden');
 
  const btn = wrapper.querySelector(".tab-close-button");
  if (btn) btn.removeAttribute('hidden');
 
  // Collapse mobile menu after selection
  const mobileToggle = wrapper.querySelector('.tab-menu-toggle');
  const tabsContainer = wrapper.querySelector('.tabs');
  if (mobileToggle && tabsContainer && window.innerWidth <= 768) {
    tabsContainer.classList.remove('mobile-expanded');
    mobileToggle.classList.remove('expanded');
    // Update toggle text to show current selection
    const label = tab.textContent.trim();
    const toggleLabel = mobileToggle.querySelector('.toggle-label');
    if (toggleLabel) toggleLabel.textContent = label;
  }
}
 
function navigateTab(wrapper, direction) {
  if (!wrapper) return;
  const tabs = Array.from(wrapper.querySelectorAll('.tab-label'));
  if (tabs.length === 0) return;
 
  const currentIndex = tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
  let nextIndex;
 
  if (currentIndex === -1) {
    nextIndex = 0;
  } else {
    nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
  }
 
  selectTab(tabs[nextIndex]);
  // Sync dropdown
  const dropdown = wrapper.querySelector('.tab-dropdown');
  if (dropdown) {
    dropdown.value = tabs[nextIndex].getAttribute('aria-controls');
  }
}
 
function loadNutritionFacts(elem) {
  try {
    const obj = JSON.parse(elem.getAttribute('data-json'));
    for (const section in obj) {
      if (typeof obj[section] === "object") {
        for (const item in obj[section]) {
          var updateItem = elem.querySelector(`#${item}`);
          if (updateItem != null) {
            if (section == "Ingredients") {
              updateItem.innerHTML = obj[section][item];
            } else {
              const spanEl = updateItem.getElementsByTagName('span')[0];
              const tdEl = updateItem.getElementsByTagName('td')[0];
              if (!spanEl || !tdEl) continue;
              spanEl.innerHTML = obj[section][item][0];
              tdEl.innerHTML = obj[section][item][1];
            }
          }
        }
      } else {
        var updateItem = section == "Ingredients"
          ? elem.querySelector(`.ingredient-container`)?.querySelector('p')
          : elem.querySelector(`#${section}`);
        if (updateItem != null) {
          updateItem.innerHTML = obj[section];
        }
      }
    }
  } catch (error) {
    console.error('Error in loadNutritionFacts:', error);
  }
}
 
function initTabWrapper(wrapper) {
  const tabs = Array.from(wrapper.querySelectorAll('.tab-label'));
  const tabsContainer = wrapper.querySelector('.tabs');
  const btn = wrapper.querySelector('.tab-close-button');
  const dropdown = wrapper.querySelector('.tab-dropdown');
  const useDropdown = tabs.length >= 5;
 
  // Switch to dropdown mode for 5+ tabs
  if (useDropdown) {
    wrapper.classList.add('use-dropdown');
  }
 
  if (dropdown) {
    dropdown.addEventListener('change', () => {
      const panelId = dropdown.value;
      // Hide all panels
      wrapper.querySelectorAll('.nutrition-facts-container').forEach(p => p.setAttribute('hidden', ''));
      // Deselect all tabs
      tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
      // Show selected panel
      const panel = document.getElementById(panelId);
      if (panel) panel.removeAttribute('hidden');
      // Sync tab state for swipe nav
      const matchingTab = tabs.find(t => t.getAttribute('aria-controls') === panelId);
      if (matchingTab) matchingTab.setAttribute('aria-selected', 'true');
      // Update mobile toggle label
      const toggleLabel = wrapper.querySelector('.tab-menu-toggle .toggle-label');
      if (toggleLabel) {
        const selected = dropdown.options[dropdown.selectedIndex];
        toggleLabel.textContent = selected.textContent;
      }
    });
  }
 
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      selectTab(tab);
      // Sync dropdown if in dropdown mode
      if (dropdown) {
        dropdown.value = tab.getAttribute('aria-controls');
      }
    });
  });
 
  // Close button
  if (btn) {
    btn.addEventListener('click', () => closeAllTabs(wrapper));
  }
 
  // Mobile toggle button
  const toggle = wrapper.querySelector('.tab-menu-toggle');
  if (toggle && tabsContainer) {
    toggle.addEventListener('click', () => {
      const isExpanded = tabsContainer.classList.toggle('mobile-expanded');
      toggle.classList.toggle('expanded', isExpanded);
    });
  }
 
  // Start mobile container collapsed so it doesn't take over the screen
  if (window.innerWidth <= 768) {
    tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.setAttribute('hidden', '');
    });
    if (btn) btn.setAttribute('hidden', '');
  }
 
  // Swipe Controls
  let touchStartX = 0;
  let touchStartY = 0;
  const SWIPE_THRESHOLD = 50;
 
  wrapper.querySelectorAll('.nutrition-facts-container').forEach((panel) => {
    panel.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
 
    panel.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;

      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) {
          navigateTab(wrapper, 1);
        } else {
          navigateTab(wrapper, -1);
        }
      }
    }, { passive: true });
  });
}
 
document.addEventListener('DOMContentLoaded', () => {
  // Load nutrition data
  const panels = Array.from(document.querySelectorAll("[id$='-nutrition-facts']"));
  for (let i = 0; i < panels.length; i++) {
    loadNutritionFacts(panels[i]);
  }
 
  // Init each tab-wrapper independently so we don't have them spawn on top of each other
  document.querySelectorAll('.tab-wrapper').forEach((wrapper) => {
    initTabWrapper(wrapper);
  });
});